export default [
    {
      path: '/gift-report',
      component: () => import('./views/Index'),
      name: 'gift-report',
      redirect: { name: 'gift-report-list' },
      children: [
        {
          path: '',
          name: 'gift-report-list',
          component: () => import('./views/List'),
          meta: {
            resource: 'auth',
          },
        },
      ],
    },
  ]